import { render, staticRenderFns } from "./labor_company.vue?vue&type=template&id=87cac1d0&scoped=true"
import script from "./labor_company.vue?vue&type=script&lang=js"
export * from "./labor_company.vue?vue&type=script&lang=js"
import style0 from "./labor_company.vue?vue&type=style&index=0&id=87cac1d0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87cac1d0",
  null
  
)

export default component.exports